import { useCallback, useMemo } from 'react'
import api from '../../services/api'

const useContacts = () => {
  const getContactAuditLogs = useCallback(async (contactId, params = {}) => {
    const { data } = await api.request({
      url: `/contacts/${contactId}/audit-logs`,
      method: 'GET',
      params
    })

    return data
  }, [])

  return useMemo(
    () => ({
      getContactAuditLogs
    }),
    [getContactAuditLogs]
  )
}

export default useContacts
